export const formatDateToDDMMYYYY = (value: Date | string | null): string => {
  if (!value) return "";

  // Jeśli przychodzi jako string i zaczyna się od 0001-01-01 → traktujemy jako brak daty
  if (typeof value === "string" && value.startsWith("0001-01-01")) {
    return "—";
  }

  const date = value instanceof Date ? value : new Date(value);

  // Dodatkowe zabezpieczenie gdyby Date było nieprawidłowe
  if (isNaN(date.getTime())) {
    return "";
  }

  // Jeśli rok = 1 → też traktujemy jako brak daty
  if (date.getFullYear() === 1) {
    return "—";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
